import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';
import { isHomebuyerPartner } from 'common/utility/helpers';

const UPTenantSupportCard = ({ utilityPartner }) => {
  const isHomebuyer = isHomebuyerPartner(utilityPartner);

  return (
    <SrCard margin="0" maxWidth="375px" padding="27px 20px">
      <SrBox display="flex" flexDirection="column">
        <SrText font="greycliff" fontSize="24px" weight="800" display="block">
          {isHomebuyer ? 'Client support covered' : 'Tenant Support? Covered.'}
        </SrText>
        <SrText font="greycliff" fontSize="14px" weight="400" display="block" marginTop="4px">
          {isHomebuyer
            ? 'We help your clients with all things utility setup.'
            : 'We help your tenants with all things utility setup.'}
        </SrText>
        <SrBox marginTop="8px" width="100%">
          <SrText font="greycliff" fontSize="16px" weight="800" display="block">
            {isHomebuyer ? 'Client Support: (737) 265-5870' : 'Tenant Support: (737) 377-1570'}
          </SrText>
          <SrText font="greycliff" fontSize="14px" weight="400" display="block" fontStyle="italic">
            Available Every Day, 8 AM–8 PM CT
          </SrText>
        </SrBox>
      </SrBox>
    </SrCard>
  );
};

UPTenantSupportCard.propTypes = {
  utilityPartner: PropTypes.object,
};

export default UPTenantSupportCard;
